<template>
    <page-container class="grid grid-cols-12 gap-8">
        <settings-sidebar></settings-sidebar>
        <div ref="content" class="col-span-12 md:col-span-8 lg:col-span-10">
            <page-loading v-if="!team"></page-loading>
            <template v-else>
                <div v-if="team.parent_id && !team.is_billable" class="max-w-(--breakpoint-sm)">
                    <page-header>Billing Details</page-header>
                    <vx-alert color="info" :closeable="false" data-test="parent-billing-alert">
                        Billing for this team is managed by your parent team.
                    </vx-alert>
                </div>
                <template v-else>
                    <team-billing-details
                        v-show="hash === 'billing-details' || !hash"
                        :team="team"
                        :isAdminOrOwner="isAdminOrOwner"
                    />

                    <team-proforma-invoices
                        v-if="team.status !== 'closed'"
                        v-show="hash === 'proforma-invoices'"
                        :teamId="team.id"
                        :paymentTermsDays="team.payment_terms_days"
                    />

                    <team-historical-invoices v-show="hash === 'historical-invoices'" :teamId="team.id" />
                </template>
            </template>
        </div>
    </page-container>
</template>

<script setup>
import TeamBillingDetails from './TeamBillingDetails.vue';
import TeamProformaInvoices from './TeamProformaInvoices.vue';
import TeamHistoricalInvoices from './TeamHistoricalInvoices.vue';
import PageContainer from '~/components/general/PageContainer.vue';
import PageLoading from '~/components/general/PageLoading.vue';
import SettingsSidebar from '../menus/SettingsSidebar.vue';
import { ref, onMounted } from 'vue';
import axios from '~/services/axios';
import { useSettingsHash } from '~/composables/useSettingsHash';
import PageHeader from '~/components/general/PageHeader.vue';
import { VxAlert } from '@voxie/frontend-components';

const { hash, content } = useSettingsHash();

const team = ref(null);

const teamId = Spark.state.currentTeam.id;
const isAdminOrOwner = Spark.isAdminOrOwner;

const getTeam = () => {
    axios.get(`/settings/teams/json/${teamId}`).then((response) => {
        team.value = response.data;
    });
};

onMounted(() => {
    getTeam();
});

Bus.$on('updateTeam', () => {
    getTeam();
});
</script>
